<template>
  <div class="chat-head chat-head--dashboard infoBox">
    <div class="chat-head__lesson">
      <div class="lesson__bg lesson__bg--dashboard">
        <img
          :src="imgSrc"
          alt="icon"
        />
      </div>

      <p class="messages__text messages__text--empty">
        <template
          v-if="isPayerPayment"
        >{{ paymentPayerStudent.first_name + ' ' + paymentPayerStudent.last_name }}</template>

        <template v-else>{{ title }}</template>
      </p>
    </div>

    <Languages
      v-if="isProfile"
      class="header-lang"
    />

    <div
      class="chat-head_right"
    >
	
      <a
        href="/chat/"
        class="btn btn-blue btn-icon icon-left"
        :class="{'is-active' : sidebarStateRight}"
      >
        {{ $t('chat') }}
        <i>
          <img
            :src="env.public_base + '/assets/images/chats-icon.svg'"
            alt="chat"
          />
        </i>
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Languages from '../chats/components/Languages';
import env from '../env';

export default {
  components: {
    Languages,
  },
  props: ['href', 'sidebarStateRight'],
  data() {
    return {
      env,
    };
  },
  computed: {
    ...mapGetters(['students_payer']),
    isProfile() {
      return this.$route.name === 'profile';
    },
    isPayer() {
      return this.$router.options.base.indexOf('payer') > -1;
    },
    isPayerPayment() {
      return (
        this.$route.name === 'student_payment' ||
        this.$route.name === 'history_payment'
      );
    },
    paymentPayerStudent() {
      return this.students_payer && this.students_payer.length
        ? this.students_payer.find((student) => {
            return +this.$route.params.child_id === student.id;
          })
        : undefined;
    },
    title() {
      const { name } = this.$route;
      let title;

      switch (name) {
        case 'dashboard':
        case 'today':
        case 'need-to-improve':
          title = this.$t('home');
          break;

        case 'diary':
          title = this.$t('diary');
          break;

        case 'curators':
          title = this.$t('curators');
          break;

        case 'documents':
          title = this.$t('documents');
          break;

        case 'achievements':
          title = this.$t('achievements');
          break;

        case 'profile':
          title = this.$t('profile');
          break;

        case 'schedules':
          title = this.$t('schedule');
          break;

        case 'schedule':
          title = this.$t('ktp');
          break;

        case 'schedule_new':
          title = this.$t('add_schedule');
          break;

        case 'gradebook':
        case 'progress_journal':
          title = this.$t('curators_journal');
          break;

        case 'timetable':
          title = this.$t('timetable');
          break;

        case 'user-info':
          title = this.$t('student_page');
          break;

        default:
          title = '';
          break;
      }

      return title;
    },
    imgSrc() {
      const { name } = this.$route;
      let src = this.env.public_base;

      const isPayer = this.$router.options.base.indexOf('payer') !== -1;

      switch (true) {
        case isPayer && name === 'profile':
          src += '/assets/images/timetable-icon.svg';
          break;

        case name === 'timetable':
          src += '/assets/images/timetable-icon.svg';
          break;

        case name === 'documents':
          src += '/assets/images/doc-icon.svg';
          break;

        case name === 'achievements':
          src += '/assets/images/achievement-icon.svg';
          break;

        case name === 'schedules':
        case name === 'schedule':
        case name === 'schedule_new':
          src += '/assets/images/icon-schedule.svg';
          break;

        default:
          src += '/assets/images/home-icon.svg';
          break;
      }

      return src;
    },
  },
  methods: {
    studentName(firstName, lastName) {
      return firstName + ' ' + lastName;
    },
  },
};
</script>

<style lang="sass" scoped>
@import "../../sass/cabinet"
@import "../../sass/teacherLesson"

.chat-head.chat-head--dashboard
  background-color: white
  padding: 13px 20px 13px 20px
  margin: 0 0 20px 0

.header-lang
  position: static
  margin-left: auto
</style>
